import Avatar from '@pelckmans/elementis/components/avatar';
import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { useTranslation } from 'react-i18next';
import { TocNodeRowHeader } from '../../../hooks/useTableData';
import { useContext } from 'react';
import { HorizontalScrollContext } from '../../../../../context/HorizontalScrollContextProvider';

export interface NodeRowHeaderProps {
  node: TocNodeRowHeader;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
}

export default function NodeRowHeader({ node, isCollapsed, toggleCollapsed }: NodeRowHeaderProps) {
  const { t } = useTranslation();
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  return (
    <CellWithHierarchy
      hierarchyProps={{
        level: node.level,
        onToggleCollapsed: toggleCollapsed,
        collapseButtonLabelText: t('PAGES.RESULTS.PER_STUDENT.TABLE.TOC_NODE.COLLAPSE_BUTTON.A11Y_LABEL'),
        collapsed: isCollapsed,
      }}
      highlighted
      density="normal"
      sticky={horizontalScroll}
    >
      <Cell.Text
        title={node.title}
        prominent
        subTitleTop={node.prefix as string}
        startAdornment={
          node.imageUrl ? (
            <Avatar>
              <AvatarImage
                size="sm"
                name={t('PAGES.RESULTS.PER_STUDENT.TABLE.TOC_NODE.AVATAR.A11Y_LABEL')}
                src={node.imageUrl}
              />
            </Avatar>
          ) : undefined
        }
      />
    </CellWithHierarchy>
  );
}
